import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatDate, formatPhoneNumber} from "page/util/helpers";

export default function Main() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    const page = searchParams.get('page') || "1";

    const navigate = useNavigate();

    const requestSearch = (e) => {
        const params = {};
        params.page = page;

        axios.get(`/admin/image-popups`, { params: params })
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    }

    const requestDelete = (id) => {
        (async () => {
            await axios.delete(`/admin/image-popups/${id}`)
            window.location.reload();
        })();
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    useEffect(() => {
        requestSearch();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">전면팝업관리</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>
                                                <button type="button"
                                                        className="btn btn-outline-info btn-sm"
                                                        style={{marginRight: '20px'}}
                                                        onClick={ () => {
                                                            navigate(`/page/app/popup/detail`);
                                                        }}>
                                                    추가
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{marginTop: '0px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>URL</th>
                                                    <th>시작일</th>
                                                    <th>종료일</th>
                                                    <th>타켓팅</th>
                                                    <th>삭제</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents && contents.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>
                                                                    <div>click >> <Link to={item.linkUrl} target="_blank">{item.linkUrl}</Link></div>
                                                                    <div>image >> <Link to={item.imageUrl} target="_blank">{item.imageUrl}</Link></div>
                                                                </td>
                                                                <td>{formatDate(item.startAt)}</td>
                                                                <td>{formatDate(item.endAt)}</td>
                                                                <td>{item.membership}</td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-danger btn-sm"
                                                                            onClick={ () => {requestDelete(item.id);}}
                                                                    >
                                                                        삭제
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>
                        }

                    </section>

                </div>
            </div>
        </div>
    );
}


